module.exports = __webpack_public_path__ + "img/will.20f37a14.png";